import { render, staticRenderFns } from "./ConfigGraduateSeparateThesisCreditDeleteDialog.vue?vue&type=template&id=32137726"
import script from "./ConfigGraduateSeparateThesisCreditDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfigGraduateSeparateThesisCreditDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports